class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
        "input",
        this.debouncedOnSubmit.bind(this)
    );

    this.querySelectorAll("sort-option").forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const value = item.getAttribute("value");
        const select = document.getElementById("SortBy");
        select.value = value;
        closeDetails(event);
        this.onSubmitHandler(event);
      });
    });

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
    FacetFiltersForm.buildSliders();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
          ? event.state.searchParams
          : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
        "ProductCountDesktop"
    );
    document
        .getElementById("ProductGridContainer")
        .querySelector(".collection")
        .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }
    sections.forEach((section) => {
      const url = `${window.location.pathname}?view=grid-view&section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [
            ...FacetFiltersForm.filterData,
            { html, url },
          ];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          FacetFiltersForm.buildSliders();
        });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const endlessCollection = new Ajaxinate({
      container: '#product-grid',
      pagination: '.infinite_next',
    });

    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");

    if (container) {
      const count = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("ProductCount").innerHTML;
      container.innerHTML = count;
      container.classList.remove("loading");
    }
    if (containerDesktop) {
      const count = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("ProductCountDesktop").innerHTML;
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
          ? element.dataset.index === jsFilter.dataset.index
          : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
        (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
          `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
      );
  }

  static buildSliders() {
    const sliders = document.querySelectorAll("[data-range-slider]");
    sliders.forEach((element) => FacetFiltersForm.buildSlider(element));
  }

  static getQueryParams(paramName) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
  }

  static getMinMaxParam(param, href) {
    const urlObj = new URL(href);
    const urlParams = new URLSearchParams(urlObj.search);
    const minParamName = `${param}.min`;
    const maxParamName = `${param}.max`;
    const min = urlParams.get(minParamName);
    const max = urlParams.get(maxParamName);

    urlParams.delete(minParamName);
    urlParams.delete(maxParamName);

    urlObj.search = urlParams.toString();
    const newUrl = urlObj.toString();
    return { min, max, newUrl };
  }

  static buildRemoveRangeFilter(paramName, minParamValue, maxParamValue) {
    const removeButtons = document.querySelectorAll('[data-remove-range="' + paramName + '"]');
    removeButtons.forEach((removeButton) => {
      const href = removeButton?.href;
      if (href) {
        const result = FacetFiltersForm.getMinMaxParam(paramName, href);
        if (result) {
          const {min, max, newUrl} = result;
          removeButton.href = newUrl;
          const rangeSelector = removeButton.querySelector('.range');
          if (rangeSelector) {
            rangeSelector.innerText = `${minParamValue} - ${maxParamValue}`;
          }
        }
      }
    });
  }
  static buildSlider(softSlider) {
    const paramName = softSlider.dataset.paramName;
    const dataRangeValues = (softSlider.dataset?.rangeValues || [])
        .split(";")
        .map((item) => +item);
    const minParamName = paramName === 'filter.v.price' ? `${paramName}.gte` : `${paramName}.min`;
    const maxParamName = paramName === 'filter.v.price' ? `${paramName}.lte` : `${paramName}.max`;
    const minQuotas = softSlider.parentElement.querySelectorAll('[data-min]');
    const maxQuotas = softSlider.parentElement.querySelectorAll('[data-max]');
    const minQuota = softSlider.parentElement.querySelector('[data-min]');
    const maxQuota = softSlider.parentElement.querySelector('[data-max]');
    const minParamValue = FacetFiltersForm.getQueryParams(minParamName);
    const maxParamValue = FacetFiltersForm.getQueryParams(maxParamName);

    // console.log('xxxxx paramName', maxParamName)
    // console.log('xxxxx maxParamValue', maxParamValue)

    const start0 = minParamValue || minQuota.dataset.min;
    const start1 = maxParamValue || maxQuota.dataset.max;


    if (minParamValue !== null) minQuotas.forEach((minQt) => minQt.value = minParamValue);
    if (maxParamValue !== null) maxQuotas.forEach((maxQt) => maxQt.value = maxParamValue);

    if (minParamValue || maxParamValue)
      FacetFiltersForm.buildRemoveRangeFilter(
          paramName,
          minParamValue,
          maxParamValue
      );

    const filterMin = parseFloat(minQuota.dataset.min);
    const filterMax = parseFloat(maxQuota.dataset.max);
    const filterMiddle = (filterMax - filterMin) / 2 + filterMin;
    const filterFirstValue = (filterMiddle - filterMin) / 2 + filterMin;
    const filterSecondValue = filterMax - (filterMax - filterMiddle) / 2;
    const defaultRangeValues = [
      filterMin,
      filterFirstValue,
      filterMiddle,
      filterSecondValue,
      filterMax,
    ];

    const sliderOptions = {
      start: [parseFloat(start0), parseFloat(start1)],
      range: {
        min: filterMin,
        max: filterMax,
      },
      pips: {
        mode: "values",
        values: defaultRangeValues,
        density: defaultRangeValues?.length,
      },
    };

    if (!softSlider?.noUiSlider) {
      noUiSlider.create(softSlider, sliderOptions);
    } else {
      softSlider.noUiSlider.updateOptions(sliderOptions);
    }
    softSlider.noUiSlider.on("change", function (values, handle, unencoded) {
      const [min, max] = values;
      minQuotas.forEach((minQt) => minQt.value = Number(min));
      maxQuotas.forEach((maxQt) => maxQt.value = Number(max));
      RangeFilter.debounceFilter(paramName, minQuota, maxQuota);
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
          activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
          html.querySelector(selector).innerHTML;
    });

    document
        .getElementById("FacetFiltersFormMobile")
        .closest("menu-drawer")
        .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
          source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sliders = document.querySelectorAll("[data-range-slider]");
    const srcEl = event.srcElement;
    const filter = srcEl.dataset.filter;
    const element = document.querySelector(`[data-param-name="${filter}"]`);
    if(element){
      const paramName = element.dataset.paramName;
      const minQuota = element.parentElement.querySelector('[data-min]');
      const maxQuota = element.parentElement.querySelector('[data-max]');

      document.querySelectorAll(`[name="${srcEl.name}"]`).forEach((element) => {
        const min = +element.getAttribute('min');
        const max = +element.getAttribute('max');
        const val = srcEl.value < min ? min : srcEl.value > max ? max : srcEl.value;
        element.value = val;
      });

      RangeFilter.debounceFilter(paramName, minQuota, maxQuota);
    } else {
      const formData = new FormData(event.target.closest("form"));
      const searchParams = new URLSearchParams(formData).toString();

      FacetFiltersForm.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
        event.currentTarget.href.indexOf("?") == -1
            ? ""
            : event.currentTarget.href.slice(
                event.currentTarget.href.indexOf("?") + 1
            );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this))
    });

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.srcElement);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

class RangeFilter extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
        element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.srcElement);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  getQueryParamsListFromUrl() {
    const urlObj = new URL(window.location.href);
    const searchParams = new URLSearchParams(urlObj.search);

    const paramList = [];

    for (const [key, value] of searchParams) {
      paramList.push({ key, value });
    }
    return paramList;
  }

  static debounceFilter = debounce((paramName, minQuota, maxQuota) => {
    const quotasList = document.querySelectorAll('[name="' + paramName + '"]');
    const minInputVal = minQuota.value;
    const maxInputVal = maxQuota.value;
    [...quotasList].forEach((item) => {
      if (item && item?.value) {
        const value = Number(item.value);
        const status = value >= minInputVal && value <= maxInputVal;
        item.checked = status;
      }
    });
    const formData = new FormData(minQuota.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, null, true);
  }, 500);
}

customElements.define("range-filter", RangeFilter);

class FacetMoreFilters extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      document.getElementById("MoreFilters").classList.toggle("hidden");
    });
  }
}

customElements.define("facet-more", FacetMoreFilters);

function closeDetails(event) {
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
